import { render, staticRenderFns } from "./openApp.vue?vue&type=template&id=3408bfc5&"
import script from "./openApp.vue?vue&type=script&lang=ts&"
export * from "./openApp.vue?vue&type=script&lang=ts&"
import style0 from "./openApp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports